import { toast } from "sonner";
import { Link2, Linkedin, Facebook } from "lucide-react";

export const shareUrl = (slug) => `${window.location.origin}/api/partage/${slug}`;

const base = "inline-flex items-center gap-2 text-xs font-semibold border border-ink/15 hover:border-ink hover:bg-ink hover:text-white transition-colors";

export const ShareButtons = ({ slug, compact = false }) => {
  const url = shareUrl(slug);
  const cls = `${base} ${compact ? "p-1.5" : "px-3 py-2"}`;
  const label = (t) => (compact ? null : t);
  const enc = encodeURIComponent(url);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Lien copié");
    } catch {
      window.prompt("Copiez ce lien :", url);
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`share-${slug}`}>
      {!compact && <span className="text-xs font-semibold uppercase tracking-[0.2em] text-ink/50 mr-1">Partager</span>}
      <button type="button" onClick={copy} className={cls} title="Copier le lien" aria-label="Copier le lien" data-testid={`share-copy-${slug}`}><Link2 size={14} />{label(" Copier le lien")}</button>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc}`} target="_blank" rel="noopener noreferrer" className={cls} title="Partager sur LinkedIn" aria-label="Partager sur LinkedIn" data-testid={`share-linkedin-${slug}`}><Linkedin size={14} />{label(" LinkedIn")}</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${enc}`} target="_blank" rel="noopener noreferrer" className={cls} title="Partager sur Facebook" aria-label="Partager sur Facebook" data-testid={`share-facebook-${slug}`}><Facebook size={14} />{label(" Facebook")}</a>
    </div>
  );
};
